import {useState, useEffect} from 'react';

type Props = {
  delayInMs?: number;
};

export const DelayedLoadingContainer: React.FC<Props> = ({
  delayInMs = 500,
  children,
}): any => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setShowContent(true);
    }, delayInMs);

    return () => {
      clearTimeout(id);
    };
  }, [delayInMs]);

  return showContent && children;
};
